"use strict";

var _default2;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var actions = _interopRequireWildcard(require("./actions"));

var _initialState = _interopRequireDefault(require("./initial-state"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var _default = (_default2 = {}, _defineProperty(_default2, actions.resetTheme, function () {
  return _objectSpread({}, _initialState["default"]);
}), _defineProperty(_default2, actions.setTheme, function (state, _ref) {
  var payload = _ref.payload;
  return _objectSpread({}, state, {}, payload);
}), _defineProperty(_default2, actions.setSchemes, function (state, _ref2) {
  var payload = _ref2.payload;
  return _objectSpread({}, state, {
    schemes: payload
  });
}), _defineProperty(_default2, actions.setSelectedScheme, function (state, _ref3) {
  var payload = _ref3.payload;
  return _objectSpread({}, state, {
    selectedScheme: payload
  });
}), _defineProperty(_default2, actions.updateScheme, function (state, _ref4) {
  var payload = _ref4.payload;
  var scheme = state.schemes.find(function (s) {
    return s.name === state.selectedScheme;
  });

  var newScheme = _objectSpread({}, payload, {
    // We make sure that if a theme is customized, its name reflects it
    name: 'user-custom'
  });

  var newSchemes = scheme ? state.schemes.map(function (s) {
    return s === scheme ? newScheme : s;
  }) : [].concat(_toConsumableArray(state.schemes), [newScheme]);
  return _objectSpread({}, state, {
    // If the host app doesn't support a widget's embedded scheme, it is shown as “Custom” in the
    // UI and the user is given the possibility to edit it
    // As soon as the user modifies it, it's named is updated to `user-custom` so we know it's not
    // an “officially” supported scheme by any host app anymore
    // For this reason, we need to set as selected the `user-custom` scheme
    selectedScheme: 'user-custom',
    schemes: newSchemes
  });
}), _default2);

exports["default"] = _default;